import { useEffect, useRef } from "react";
import { useState } from "react";
import { Line } from "react-chartjs-2";
import api from "../../../services/api";
import { faCircleArrowDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from '../../../utils/momentConfig';

const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top' as const,
        }
    },
};

export const dataChart = {
  labels: [],
  datasets: [
    {
      label: "Membros",
      data: [],
      borderColor: "rgb(255, 99, 132)",
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
  ],
};

interface ChartDTO {
  year: number;
  baptized: number;
  congregation: string;
}

interface Params {
  refresh: boolean;
  year: number;
  byCongregation?: boolean;
  idCongregation?: number;
}

const MemberBaptizedChart = ({ refresh, year, byCongregation, idCongregation }: Params) => {
  const [graphData, setGraphData] = useState<any>();
  const [hasError, setError] = useState<boolean>();
  const chartRef = useRef<any>(null);

  useEffect(() => {    
    init();
  }, [refresh, year, byCongregation, idCongregation]);

  const init = async () => {
    try {
      setGraphData(null);

      let params = {
        year: year,
        byCongregation: byCongregation,
        idCongregation: idCongregation
      } as any;

      const { data } = await api.get("/members/chart/baptized", {
        params: params
      })

      if (!data.success) {
        setError(true);
        return;
      }

      if (!data.item) {
        setError(true);
        return;
      }

      setGraphData(data.item);

      dataChart.labels = data.item.map((c: ChartDTO) => {
        return [ handleLabel(c) ];
      });
      dataChart.datasets[0].data = data.item.map((c: ChartDTO) => {
        return c.baptized;
      });

    } catch (ex) {
      console.log(ex);
      setGraphData(null);
      setError(true);
    }
  };

  const handleLabel = (c: ChartDTO) => {
    if (byCongregation && c.congregation) {
      return `${c.congregation} (${c.baptized})`;
    }
    return `${c.year}, ${c.baptized} ${c.baptized == 1 ? "batizado" : "batizados"}`;
  }

  const handleExport = () => {
    if (!chartRef.current) return;

    const chart = chartRef.current; 
    const url = chart.toBase64Image();
    
    const a = document.createElement('a');
    a.href = url;
    a.download = `membros-batizados-${moment().valueOf()}.png`;
    a.click();
  };

  return (
    <div className="uk-grid-small" uk-grid="true">
      <div className="uk-width-1@m">
        <h3 className="uk-text-center uk-text-bold uk-margin-remove-bottom">
          Membros Batizados por Ano {byCongregation ? "por Congregação" : ""}
          {(!hasError && graphData && dataChart.labels.length > 0) &&
            <FontAwesomeIcon icon={faCircleArrowDown}
              className='uk-text-primary uk-margin-small-left cursor-pointer'
              onClick={handleExport}
              uk-tooltip="title: Exportar Imagem do Gráfico; pos: top"
              size='sm' />
          }
        </h3>
        <h5 className="uk-text-center uk-text-bold uk-margin-remove-top">
          {byCongregation && (!idCongregation || idCongregation <= 0) ? `${year}` : `De ${graphData ? graphData[0]?.year : '-'} à ${year}`}          
        </h5>
      </div>
      <div className="uk-width-1@m uk-flex uk-flex-center">
        {hasError === true ? (
          <span className="uk-label uk-label-danger uk-text-center">
            Não foi possível carregar o gráfico dos batizados
          </span>
        ) : !graphData ? (
          <div className="uk-text-center" uk-spinner="true; ratio:2">
            Carregando...
          </div>
        ) : (
          <Line data={dataChart} ref={chartRef} options={options} />
        )}
      </div>
    </div>
  );
};

export default MemberBaptizedChart;
